import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ef6a080"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg class=\"radio__icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0ef6a080><rect class=\"icon_rect_one\" x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" rx=\"7.5\" fill=\"white\" data-v-0ef6a080></rect><rect class=\"icon_rect_two\" x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" rx=\"7.5\" stroke=\"#8891AA\" data-v-0ef6a080></rect><rect width=\"16\" height=\"16\" rx=\"8\" fill=\"white\" fill-opacity=\"0.01\" data-v-0ef6a080></rect><circle cx=\"8\" cy=\"8\" r=\"3\" fill=\"white\" data-v-0ef6a080></circle></svg>", 1)
const _hoisted_3 = { class: "radio__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkRadio", { 'OkRadio--disabled': _ctx.disabled }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (radio) => {
      return (_openBlock(), _createElementBlock("label", {
        class: _normalizeClass(["OkRadio__radio", {
                'radio--active': _ctx.isRadioActive(radio),
                'radio--disabled': _ctx.isRadioDisabled(radio),
            }]),
        key: radio.id,
        onClick: ($event: any) => (_ctx.onClick(radio))
      }, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(radio[_ctx.label]), 1)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}